import { ApolloProvider } from '@apollo/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import React, { Suspense } from 'react';
import { CookiesProvider } from 'react-cookie';
import ReactDOM from 'react-dom/client';

import Loader from './components/common/Loader';
import Router from './Router';
import { AlertProvider } from './utilities/alert';
import apollo from './utilities/apollo';
import { AuthProvider } from './utilities/auth';
import ConfigurationsProvider from './utilities/configurations';
import NotificationsProvider from './utilities/notification';
import theme from './utilities/theme';
import { BrowserRouter } from 'react-router-dom';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <CookiesProvider>
      <ApolloProvider client={apollo}>
        <AuthProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <ThemeProvider theme={theme}>
              <AlertProvider>
                <NotificationsProvider>
                  <ConfigurationsProvider>
                    <CssBaseline />
                    <Suspense fallback={<Loader />}>
                      <BrowserRouter>
                        <Router />
                      </BrowserRouter>
                    </Suspense>
                  </ConfigurationsProvider>
                </NotificationsProvider>
              </AlertProvider>
            </ThemeProvider>
          </LocalizationProvider>
        </AuthProvider>
      </ApolloProvider>
    </CookiesProvider>
  </React.StrictMode>,
);
